import { nave4AccionesRoles } from '../../acciones-roles/departamentos/nave4-acciones-roles';
import { SideBarButton } from '../../nav-list/recursive-sidebar/class/sidebar';
import {
  PreConfigButton2,
  PreConfigButton3,
} from '../../nav-list/recursive-sidebar/configuration/preconfig';

export const nave4NavRoutes: SideBarButton = {
  data: {
    name: 'Nave 4',
    appendUrl: './nave4',
    roles: [...nave4AccionesRoles.sideNavActions.root],
  },
  options: PreConfigButton2,
  butons: [
    {
      data: {
        name: 'Planeacion',
        url: '/scheduler',
        roles: [...nave4AccionesRoles.sharedActions.scheduler],
        otherUniqueUrls: [
          '/scheduler/pintar',
          '/scheduler/doblar',
          '/scheduler/soldar',
        ],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Limpieza',
        url: '/cleaning',
        roles: [...nave4AccionesRoles.sharedActions.cleaning],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Validacion',
        url: '/validation',
        roles: [...nave4AccionesRoles.sharedActions.validation],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Etiquetas',
        url: '/packing-box',
        roles: nave4AccionesRoles.sharedActions.packingBox,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Reporte Power BI',
        overWriteUrl: './reportsPBI/nave4',
        // roles: [...nave4AccionesRoles.sideNavActions.reportsPbiNave4],
      },
      options: PreConfigButton3,
    },
  ],
};
